<template>
    <div
        class="modal toFtth fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
    >
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title" id="myModalLabel">
                        Listagem de CTOS
                    </h4>
                </div>
                <div class="modal-body">
                    <list-ctos
                        v-if="!cto_id"
                        @clicked="clicked($event)"
                    ></list-ctos>

                    <div class="form-group" v-if="cto_id">
                        <div class="col-sm-3">
                            <br />
                            <label for="senha" class="control-label"
                                >MAC:</label
                            >
                            <input
                                id="senha"
                                type="text"
                                v-model="mac"
                                class="form-control"
                            />
                        </div>
                    </div>

                    <div class="form-group" v-if="cto_id">
                        <div class="col-sm-10">
                            <button
                                type="button"
                                :disabled="!mac"
                                @click="save()"
                                class="btn btn-success"
                            >
                                <i
                                    class="fa fa-floppy-o"
                                    aria-hidden="true"
                                ></i>
                                SALVAR FTTH
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListCtos from "../../components/lists/ListCtos";
import { Contratos } from "../../class/index";

/* global swal */
export default {
    class: "toFtth",
    name: "ToFtth",
    components: {
        ListCtos
    },

    props: {
        id: null
    },

    data() {
        return {
            cto_id: null,
            mac: null
        };
    },

    methods: {
        clicked(id) {
            this.cto_id = id;
        },

        save() {
            let json = {
                cto_id: this.cto_id,
                contrato_id: this.id,
                mac: this.mac
            };

            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar a FTTH?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Contratos.updateFtth(json)
                                .then(() => {
                                    this.$emit("saved");
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);

        }
    }
};
</script>

<style scoped></style>
